<template>
  <div>
    <v-navigation-drawer
      class="pa-3"
      style="z-index: 1"

      fixed
      clipped
      app
    >
      <document-list
        :documents="documents"
      />
    </v-navigation-drawer>
    <v-layout justify-center align-center style="height: calc(100vh - 64px)">
      <PdfViewer
        presentation="true"
        v-show="documentsLoaded && !loading"
        v-bind="{url}"
        @document-rendered="onDocumentRendered"
        @document-errored="showPDFError"
      />
      <v-layout
        v-show="!documentsLoaded"
        column
        align-center
      >
        <v-icon color="grey" class="mb-2 text--darken-2" size="64">mdi-file-hidden</v-icon>
        <span class="title grey--text text--darken-3">Nenhum documento selecionado!</span>
        <span class="subtitle">Selecione um documento na ao lado</span>
      </v-layout>
    </v-layout>
    <loader-dialog :showLoader="loading" message="Carregando documentos..." />
  </div>
</template>

<script>
import PdfViewer from '@/components/pdf/PdfViewer';
import DocumentList from '@/components/document/list/DocumentList';
import LoaderDialog from '@/components/LoaderDialog';
import bus from '@/utils/event-bus';
import { last } from 'lodash';

export default {
  name: 'PresentationMode',
  components: {
    DocumentList,
    LoaderDialog,
    PdfViewer,
  },
  data() {
    return {
      loading: false,
      documentsLoaded: false,
      url: '',
    };
  },
  methods: {
    onDocumentRendered() {
      this.documentsLoaded = true;
      this.loading = false;
    },
    showPDFError() {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: 'Não foi possível carregar o PDF. Tente atualizar a página e caso o erro persista, entrar em contato com o suporte!',
        button: { show: true, text: 'Fechar', message: '' },
        timeout: 6000,
        messageIcon: 'mdi-alert-outline',
      });
    },
    loadDocument(doc) {
      this.loading = true;
      const file = last(doc.document_versions).file;
      bus.$emit('load-pdf', file);
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    documents() {
      return this.folder.documents;
    },
    lastVersionDocs() {
      const pdfs = this.documents.filter(doc => doc.mime_type === 'application/pdf');
      return pdfs.map(doc => last(doc.document_versions));
    },
    files() {
      return this.lastVersionDocs.map(item => item.file);
    },
  },
};
</script>

<style scoped>
  .pdf-viewer__document {
    top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/document/presentation/PresentationMode.vue